<template>
  <div :class="['popover-tips-body', fissionGame]" v-if="showPopoverTip">
    <img class="coupon-icon" v-lazy="iconSrc" alt="logo" />
    <div class="text">
      <!-- 注册提示 -->
      <template v-if="!!registerAwardsType && btnType === 'register'">
        <span>{{ descForNewUser }}</span>
        <!-- 注册得积分提示 -->
        <!-- <i18n
          path="fission.register-rules1"
          tag="span"
          v-if="registerAwardsType === 'point'"
        >
          <span place="amount">{{ registerAwardsNum }}</span>
        </i18n> -->
        <!-- 注册得优惠券：立减券 -->
        <!-- <i18n
          path="fission.register-rules3"
          tag="span"
          v-if="registerAwardsType === 'coupon' && couponType * 1 === 1"
        >
          <span place="amount">{{ registerAwardsNum }}</span>
          <span place="currencySymbol">{{ currencySymbol }}</span>
        </i18n> -->
        <!-- 注册得优惠券：折扣券 -->
        <!-- <i18n
          path="fission.register-rules2"
          tag="span"
          v-if="registerAwardsType === 'coupon'"
        >
          <span place="amount">{{ registerAwardsNum }}</span>
          <span place="amount">50</span>
        </i18n> -->
      </template>
      <!-- 分享提示 -->
      <template v-else-if="btnType === 'share'">
        <span>{{ shareDesc }}</span>
        <!-- 已完成首次分享 -->
        <!-- <i18n
          path="fission.share-to-get-rules3"
          tag="span"
          v-if="shareDesc"
        >
          <span place="amount">{{ discount }}</span>
        </i18n> -->
        <!-- 未完成首次分享 -->
        <!-- <i18n path="fission.share-to-get-rules1" tag="span" v-else>
          <span place="amount">{{ discount }}</span>
        </i18n> -->
      </template>
      <template v-else> {{ text }}</template>
    </div>
    <span class="triangle"></span>
  </div>
</template>
<script>
  import { mapState } from 'vuex'
  import { styleInfo } from '@/pages/Activity/Fission/configData.js'

  export default {
    props: {
      text: {
        type: String,
        default: '',
      },
      registerAwardsType: {
        type: String,
        default: '',
      },
      registerAwardsNum: {
        type: [String, Number],
        default: '',
      },
      couponType: {
        type: [Number, String],
        default: '',
      },
      currencySymbol: {
        type: String,
        default: 'RM',
      },
      btnType: {
        type: String,
        default: '',
      },
      shareDesc: {
        type: String,
        default: '',
      },
      discount: {
        type: String,
        default: '50',
      },
    },
    computed: {
      ...mapState(['fissionInfos', 'fissionGame']),
      descForNewUser() {
        const { extraInfo } = this.fissionInfos || {}
        // 有可能未配置
        return extraInfo?.toShareRegisterButtonDesc
      },
      showPopoverTip() {
        if (this.registerAwardsType && this.btnType === 'register') {
          return !!this.descForNewUser
        } else if (this.btnType === 'share') {
          return !!this.shareDesc
        } else {
          return !!this.text
        }
      },
      iconSrc() {
        return styleInfo[this.fissionGame].icon.popoverCoupon
      },
    },
  }
</script>
<style lang="scss" scoped>
  .popover-tips-body {
    font-family: 'MiSans', 'Noto Sans';
    position: absolute;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: auto;
    max-width: 120%;
    max-height: 80px;
    min-height: 70px;
    border-radius: 47px;
    padding: 0 20px;
    box-sizing: border-box;
    .coupon-icon {
      width: 60px;
      height: 60px;
      margin-left: 12px;
      // transform: scale(1.2);
      &.score-icon {
        transform: scale(2);
      }
    }
    .text {
      font-weight: 600;
      font-size: 30px;
      line-height: 115%;
      color: #cbd0df;
      margin-left: 10px;
      flex: 1;
      @include canWrap($lineCount: 2);
    }
    // 区分页面和弹窗内的文案大小
    &.page {
      .text > span {
        font-size: 26px;
      }
    }
    &.popup {
      .text {
        font-size: 24px;
      }
    }
    .triangle {
      position: absolute;
      width: 0;
      height: 0;
      left: 60%;
      border-right: 10px solid transparent;
      border-top: 10px solid transparent;
      border-left: 10px solid transparent;
      border-bottom: 20px solid#0D41C9;
      transform: translateY(-170%);
      z-index: -1;
    }
    &.mobile-legends {
      background-color: #0d43ca;
      .triangle {
        border-bottom: 20px solid#0D41C9;
      }
    }
    &.pubgm {
      background-color: #1e2227;
      .triangle {
        border-bottom: 20px solid #1e2227;
      }
    }
    &.genshin {
      background: rgba(75, 82, 100, 1);
      .triangle {
        border-bottom: 20px solid rgba(75, 82, 100, 1);
      }
    }
  }
</style>
